import * as React from 'react'
import PropTypes from 'prop-types'

import * as forms from '@rushplay/forms'
import * as common from '@rushplay/common'
import { useI18n } from '@rushplay/i18n'

import { CheckboxGroup } from './checkbox-group'
import { InputField } from './input-field'
import { SelectField } from './select-field'
import { SubmitButton } from './submit-button'

function NumberField(props) {
  return <InputField inputMode="numeric" {...props} />
}

function Text(props) {
  const i18n = useI18n()
  return <common.Text {...props}>{i18n.translate(props.children)}</common.Text>
}

export function FieldBuilder(props) {
  return (
    <forms.FieldBuilder
      components={{
        numberField: NumberField,
        submit: SubmitButton,
        text: Text,
        textField: InputField,
        singleSelectField: SelectField,
        multipleSelectField: CheckboxGroup,
        ...props.components,
      }}
      disabled={props.disabled}
      getComponent={props.getComponent}
      getCustomField={props.getCustomField}
      mountPoint="forms"
      name={props.name}
      initialValues={props.initialValues}
      uiSchema={props.uiSchema}
    />
  )
}

Text.propTypes = {
  children: PropTypes.node,
}

FieldBuilder.propTypes = {
  components: PropTypes.object,
  disabled: PropTypes.bool,
  getComponent: PropTypes.func,
  getCustomField: PropTypes.func,
  initialValues: PropTypes.object,
  name: PropTypes.string,
  uiSchema: PropTypes.object.isRequired,
}
